import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Contact/Group list row placeholder — mirrors ContactV3/Contact's
 * guaranteed content: a 40x40 avatar, one name-shaped line, and the
 * trailing radio-button/select affordance shown in edit mode. The name is
 * the only line those rows always render — a second line (email, role,
 * "already invited") only appears conditionally on the contact's data, so
 * the skeleton doesn't guess at a line that may not show (TA-10393).
 */
export const ContactRowSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'contact-row-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      justifyContent='space-between'
      paddingVertical='xs'>
      <Skeleton variant='circle' width={40} height={40} />
      <Box flex={1} style={{ marginLeft: theme.spacing.xs }}>
        <Skeleton variant='text' width='40%' />
      </Box>
      <Skeleton
        variant='circle'
        width={20}
        height={20}
        style={{ marginLeft: theme.spacing.xs }}
      />
    </Box>
  );
};
